


















import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  model: {
    prop: "days",
    event: "change"
  }
})
export default class CheckDayOfWeek extends Vue {
  @Prop({ default: () => [] }) days!: number[];

  // TODO 祝日の有無を切り替えられるようにする
  daysOfWeek = ["日", "月", "火", "水", "木", "金", "土", "祝"];
  // daysOfWeek = ["日", "月", "火", "水", "木", "金", "土"];

  get daysChecked() {
    return this.days;
  }

  set daysChecked(days: number[]) {
    this.$emit("change", days);
  }
}
